var _defs, _rect, _polygon, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGuideMaterial15(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 425.45 425.45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#f04e23;}.cls-3{fill:none;stroke:#ffcb05;stroke-miterlimit:10;stroke-width:0.25px;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8162.12,
    y1: 3568.86,
    x2: 8162.12,
    y2: 3143.66,
    gradientTransform: "translate(8374.85 3568.98) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d60f84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#812990"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.13,
    y: 0.13,
    width: 425.2,
    height: 425.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "425.32 425.19 361.54 318.89 297.76 425.19 425.32 425.19"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 425.32,
    x2: 0.13,
    y2: 0.12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 425.32,
    y1: 425.32,
    x2: 425.32,
    y2: 0.13
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 425.32,
    x2: 425.32,
    y2: 425.32
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 425.32,
    y1: 0.13,
    x2: 0.13,
    y2: 0.13
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 382.8,
    x2: 425.32,
    y2: 382.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 340.28,
    x2: 425.32,
    y2: 340.28
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 297.76,
    x2: 425.32,
    y2: 297.76
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 255.24,
    x2: 425.32,
    y2: 255.24
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 212.72,
    x2: 425.32,
    y2: 212.72
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 170.2,
    x2: 425.32,
    y2: 170.2
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 127.68,
    x2: 425.32,
    y2: 127.68
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 85.16,
    x2: 425.32,
    y2: 85.16
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 42.64,
    x2: 425.32,
    y2: 42.64
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 404.06,
    x2: 425.32,
    y2: 404.06
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 361.54,
    x2: 425.32,
    y2: 361.54
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 319.02,
    x2: 425.32,
    y2: 319.02
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 276.5,
    x2: 425.32,
    y2: 276.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 233.98,
    x2: 425.32,
    y2: 233.98
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 191.46,
    x2: 425.32,
    y2: 191.46
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 148.94,
    x2: 425.32,
    y2: 148.94
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 106.42,
    x2: 425.32,
    y2: 106.42
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 63.9,
    x2: 425.32,
    y2: 63.9
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 0.13,
    y1: 21.38,
    x2: 425.32,
    y2: 21.38
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 382.8,
    y1: 425.32,
    x2: 382.8,
    y2: 0.13
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 340.28,
    y1: 425.32,
    x2: 340.28,
    y2: 0.13
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 297.76,
    y1: 425.32,
    x2: 297.76,
    y2: 0.13
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 255.24,
    y1: 425.32,
    x2: 255.24,
    y2: 0.13
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 212.72,
    y1: 0.13,
    x2: 212.72,
    y2: 425.32
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 170.2,
    y1: 425.32,
    x2: 170.2,
    y2: 0.13
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 127.68,
    y1: 425.32,
    x2: 127.68,
    y2: 0.13
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 85.16,
    y1: 425.32,
    x2: 85.16,
    y2: 0.12
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 42.64,
    y1: 425.32,
    x2: 42.64,
    y2: 0.12
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 404.06,
    y1: 425.32,
    x2: 404.06,
    y2: 0.13
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 361.54,
    y1: 425.32,
    x2: 361.54,
    y2: 0.13
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 319.02,
    y1: 425.32,
    x2: 319.02,
    y2: 0.13
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 276.5,
    y1: 425.32,
    x2: 276.5,
    y2: 0.13
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 233.98,
    y1: 425.32,
    x2: 233.98,
    y2: 0.13
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 191.46,
    y1: 425.32,
    x2: 191.46,
    y2: 0.13
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 148.94,
    y1: 425.32,
    x2: 148.94,
    y2: 0.13
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 106.42,
    y1: 425.32,
    x2: 106.42,
    y2: 0.13
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 63.9,
    y1: 425.32,
    x2: 63.9,
    y2: 0.12
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 21.38,
    y1: 425.32,
    x2: 21.38,
    y2: 0.12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuideMaterial15);
export default __webpack_public_path__ + "static/media/guideMaterial15.8139dfa586712aeb9f770e5863acd040.svg";
export { ForwardRef as ReactComponent };